import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// One-time Google OAuth callback: exchanges the session_id fragment for our
// normal cookie session, then drops the user on their account page.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        if (!sessionId) throw new Error("missing session_id");
        const user = await googleSession(sessionId);
        navigate("/account", { replace: true, state: { user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, googleSession, navigate]);

  return (
    <div
      className="min-h-screen bg-[var(--mm-bg)] flex flex-col items-center justify-center gap-4"
      data-testid="auth-callback"
    >
      <Loader2 size={28} className="animate-spin text-[var(--mm-accent)]" />
      <p className="text-sm tracking-[0.2em] uppercase text-[var(--mm-cream-muted)]">
        Signing you in…
      </p>
    </div>
  );
}
